<template>
  <transition name="modal-fade">
    <body-portal v-if="value">
      <div
        class="confirm-modal-overlay"
        @click.self="handleOverlayClick"
      >
        <div
          class="confirm-modal confirm-modal--schedule-subscription"
          role="dialog"
          aria-modal="true"
          aria-labelledby="schedule-subscription-prompt-title"
        >
          <div class="confirm-modal-header schedule-subscription-prompt-header">
            <h3 id="schedule-subscription-prompt-title" class="confirm-modal-title">
              {{ scheduleSubscriptionPromptTitle }}
            </h3>
            <button
              type="button"
              class="confirm-modal-close"
              :aria-label="tt('common.close', 'Cerrar')"
              @click="closeModal"
            >
              <i class="ti-close"></i>
            </button>
          </div>
          <div class="confirm-modal-body schedule-subscription-prompt-body">
            <div class="schedule-subscription-prompt-layout">
              <div class="schedule-subscription-prompt-copy">
                <p class="confirm-modal-subtitle schedule-subscription-prompt-text">
                  {{ scheduleSubscriptionPromptBody }}
                </p>
                <ul class="schedule-subscription-benefits">
                  <li class="schedule-subscription-benefit-item">
                    <i class="ti-check"></i>
                    <span>
                      {{ tt("makeClips.scheduleSubscriptionPromptBenefitTokens", "720 tokens al día para publicar clips sin fricción.") }}
                    </span>
                  </li>
                  <li class="schedule-subscription-benefit-item">
                    <i class="ti-check"></i>
                    <span>
                      {{ tt("makeClips.scheduleSubscriptionPromptBenefitEditor", "Edita tus clips: ajusta el inicio y final, cambia el tipo de video y vuelve a renderizar sin perder el flujo.") }}
                    </span>
                  </li>
                  <li class="schedule-subscription-benefit-item">
                    <i class="ti-check"></i>
                    <span>
                      {{ tt("makeClips.scheduleSubscriptionPromptBenefitEndCard", "Agrega una pantalla final con tu @ y una imagen personalizada para que cada clip cierre con tu marca.") }}
                    </span>
                  </li>
                  <li class="schedule-subscription-benefit-item">
                    <i class="ti-check"></i>
                    <span>
                      {{ tt("makeClips.scheduleSubscriptionPromptBenefitWatermark", "Elimina la marca de agua y mejora la percepción de tu marca.") }}
                    </span>
                  </li>
                  <li class="schedule-subscription-benefit-item">
                    <i class="ti-check"></i>
                    <span>
                      {{ tt("makeClips.scheduleSubscriptionPromptBenefitScale", "Conecta tus redes sociales y programa tus publicaciones para acelerar tu crecimiento.") }}
                    </span>
                  </li>
                </ul>
                <p class="schedule-subscription-proof">
                  {{ tt("makeClips.scheduleSubscriptionPromptProof", "Activa tu suscripción en menos de un minuto y sigue programando sin salir del flujo.") }}
                </p>
              </div>
              <figure class="schedule-subscription-preview">
                <img
                  :src="scheduleSubscriptionPromptImageSrc"
                  class="schedule-subscription-preview-image"
                  :alt="tt('makeClips.scheduleSubscriptionPromptImageAlt', 'Vista previa del watermark en un clip generado')"
                />
                <figcaption class="schedule-subscription-preview-caption">
                  {{ tt("makeClips.scheduleSubscriptionPromptImageCaption", "Con Unlimited puedes editar tus clips, quitar la marca de agua y cerrar cada video con una pantalla final personalizada.") }}
                </figcaption>
              </figure>
            </div>
          </div>
          <div class="confirm-modal-footer schedule-subscription-prompt-footer">
            <button
              type="button"
              class="confirm-modal-btn confirm-modal-btn--primary"
              @click="$emit('subscribe')"
            >
              {{ tt("makeClips.scheduleSubscriptionPromptSubscribeCta", "Suscribirme") }}
            </button>
          </div>
        </div>
      </div>
    </body-portal>
  </transition>
</template>

<script>
export default {
  name: "ScheduleSubscriptionPromptModal",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    hasActivePlan: {
      type: Boolean,
      default: false,
    },
    closeOnOverlay: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    scheduleSubscriptionPromptTitle() {
      if (this.hasActivePlan) {
        return this.tt(
          "makeClips.scheduleSubscriptionPromptTitleWithSubscription",
          "Tu suscripción Unlimited"
        );
      }
      return this.tt(
        "makeClips.scheduleSubscriptionPromptTitleNoSubscription",
        "Pasa a Unlimited"
      );
    },
    scheduleSubscriptionPromptBody() {
      if (this.hasActivePlan) {
        return this.tt(
          "makeClips.scheduleSubscriptionPromptBodyWithSubscription",
          "Tu cuenta ya tiene una suscripción activa con tokens diarios y clips sin marca de agua."
        );
      }
      return this.tt(
        "makeClips.scheduleSubscriptionPromptBodyNoSubscription",
        "Con Unlimited obtienes 720 tokens al día, puedes editar tus clips, personalizar la pantalla final y eliminar la marca de agua."
      );
    },
    scheduleSubscriptionPromptImageSrc() {
      return require("@/assets/img/modals/water-mark-example.webp");
    },
  },
  methods: {
    tt(key, fallback) {
      return typeof this.$t === "function" ? this.$t(key) : fallback;
    },
    closeModal() {
      this.$emit("input", false);
      this.$emit("close");
    },
    handleOverlayClick() {
      if (!this.closeOnOverlay) return;
      this.closeModal();
    },
  },
};
</script>

<style scoped>
.confirm-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(88, 28, 135, 0.28);
  backdrop-filter: blur(8px);
}

.confirm-modal--schedule-subscription {
  width: min(860px, 96vw);
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  border: 1px solid rgba(168, 85, 247, 0.4);
  background:
    radial-gradient(120% 120% at 0% 0%, rgba(168, 85, 247, 0.18) 0%, rgba(14, 23, 42, 0) 45%),
    radial-gradient(90% 90% at 100% 100%, rgba(217, 70, 239, 0.14) 0%, rgba(15, 23, 42, 0) 48%),
    linear-gradient(180deg, rgba(17, 24, 39, 0.98) 0%, rgba(9, 12, 26, 0.99) 100%);
  box-shadow:
    0 32px 70px rgba(3, 7, 18, 0.85),
    0 0 0 1px rgba(196, 181, 253, 0.12),
    0 0 42px rgba(168, 85, 247, 0.2);
}

.schedule-subscription-prompt-header {
  position: relative;
  padding: 24px 56px 16px;
  text-align: center;
  border-bottom: 1px solid rgba(148, 163, 184, 0.16);
  background: linear-gradient(135deg, rgba(91, 33, 182, 0.2) 0%, rgba(15, 23, 42, 0.25) 55%, transparent 100%);
}

.schedule-subscription-prompt-header .confirm-modal-title {
  margin: 0;
  font-size: 1.8rem;
  letter-spacing: -0.02em;
}

.confirm-modal-close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--clipr-border-color);
  border-radius: 8px;
  background: transparent;
  color: var(--clipr-text-secondary);
  cursor: pointer;
}

.schedule-subscription-prompt-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px 24px;
  padding-top: 20px;
  padding-bottom: 20px;
}

.schedule-subscription-prompt-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(260px, 320px);
  gap: 24px;
  align-items: center;
}

.schedule-subscription-prompt-copy {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.schedule-subscription-prompt-text {
  margin: 0;
  font-size: 1.03rem;
  line-height: 1.6;
  color: var(--clipr-text-primary);
}

.schedule-subscription-benefits {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.schedule-subscription-benefit-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 0.88rem;
  line-height: 1.45;
  color: var(--clipr-text-secondary);
}

.schedule-subscription-benefit-item i {
  margin-top: 2px;
  color: #d8b4fe;
  font-size: 0.78rem;
}

.schedule-subscription-proof {
  margin: 0;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid rgba(217, 70, 239, 0.25);
  background: rgba(168, 85, 247, 0.1);
  color: #f5d0fe;
  font-size: 0.8rem;
  line-height: 1.4;
}

.schedule-subscription-preview {
  position: relative;
  margin: 0;
  justify-self: end;
  width: 100%;
  max-width: 310px;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(217, 70, 239, 0.4);
  background: linear-gradient(180deg, rgba(15, 23, 42, 0.95) 0%, rgba(2, 6, 23, 0.98) 100%);
  box-shadow:
    0 20px 42px rgba(2, 6, 23, 0.6),
    0 0 0 1px rgba(168, 85, 247, 0.18);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.schedule-subscription-preview:hover {
  transform: translateY(-2px);
  box-shadow:
    0 26px 52px rgba(2, 6, 23, 0.68),
    0 0 0 1px rgba(216, 180, 254, 0.24);
}

.schedule-subscription-preview-image {
  width: 100%;
  max-height: 220px;
  object-fit: cover;
  object-position: top center;
  display: block;
}

.schedule-subscription-preview-caption {
  margin: 0;
  padding: 12px 14px;
  font-size: 0.78rem;
  line-height: 1.45;
  color: #dbe2f1;
  background: linear-gradient(180deg, rgba(8, 47, 73, 0.18) 0%, rgba(15, 23, 42, 0.98) 100%);
}

.schedule-subscription-prompt-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  padding: 16px 24px 24px;
  border-top: 1px solid var(--clipr-border-color);
  background: var(--clipr-purple-overlay-medium);
}

.schedule-subscription-prompt-footer .confirm-modal-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 180px;
  padding: 10px 20px;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  color: #fff;
}

.schedule-subscription-prompt-footer .confirm-modal-btn--primary {
  background: linear-gradient(135deg, #a855f7 0%, #d946ef 55%, #f472b6 100%);
  box-shadow:
    0 14px 28px rgba(168, 85, 247, 0.38),
    0 0 20px rgba(217, 70, 239, 0.3);
}

.schedule-subscription-prompt-footer .confirm-modal-btn--primary:hover:not(:disabled) {
  transform: translateY(-1px) scale(1.01);
}

@media (max-width: 768px) {
  .confirm-modal--schedule-subscription {
    width: min(620px, 96vw);
  }

  .schedule-subscription-prompt-header .confirm-modal-title {
    font-size: 1.5rem;
  }

  .schedule-subscription-prompt-layout {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .schedule-subscription-preview {
    justify-self: start;
    max-width: 250px;
  }

  .schedule-subscription-preview-image {
    max-height: 180px;
  }

  .schedule-subscription-prompt-footer {
    gap: 10px;
  }

  .schedule-subscription-prompt-footer .confirm-modal-btn {
    min-width: 0;
    flex: 1;
  }
}
</style>
